<template>
  <div class="purchase-order-template">
    <PageHeaderCount
      moduleType="purchase.order"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_purchase_orders"
      countkey="purchase_order_status_count"
    ></PageHeaderCount>
    <ListingTemplate :customClass="'purchase-order-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 my-auto">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('purchase-order:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(item, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="bulkAction(item.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              item.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0 mxw-200">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="item.description"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_purchase_orders
                          }}</template>
                          <template v-else>{{
                            item.purchase_order_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-flex>
              <v-flex
                class="pt-0 pr-0 justify-flex-end d-flex purchase-order-listing-button-right"
              >
                <template v-if="getPermission('purchase-order:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color"
                    :to="getDefaultRoute('purchase.order.create')"
                    color="white--text"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <!-- <v-btn
                  depressed
                  v-if="!isEngineerChannel()"
                  v-on:click="
                    $router.push(
                      getDefaultRoute('profile.setting', {
                        query: {
                          tab: 'purchase-order',
                        },
                      })
                    )
                  "
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                >
                  <v-icon dark>mdi-cog</v-icon>
                </v-btn> -->
                <!-- <v-menu content-class="custom-menu-list" offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading || exportLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                      :loading="exportLoading"
                    >
                      <v-icon dark>mdi-menu</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <template v-for="(item, index) in moreActions">
                      <v-list-item
                        :key="index"
                        link
                        :class="{ 'line-active': item.sort }"
                        v-on:click="moreAction(item.action, item.sort)"
                      >
                        <v-list-item-title>
                          <v-icon v-if="item.icon" small left color="cyan">{{
                            item.icon
                          }}</v-icon>
                          {{ item.title }}
                          <template v-if="item.sort">
                            <v-icon
                              v-if="item.sort == 'asc'"
                              small
                              right
                              color="cyan"
                              >mdi-sort-ascending</v-icon
                            >
                            <v-icon
                              v-if="item.sort == 'desc'"
                              small
                              right
                              color="cyan"
                              >mdi-sort-descending</v-icon
                            >
                          </template>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu> -->
                <v-menu
                  max-height="400"
                  max-width="260"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          v-on:change="updateVisible()"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon class="draggable-drag-icon" right color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <PageTips v-if="false" module="purchase-order"></PageTips>
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Purchase Order"
          :basicSearchFields="['barcode', 'reference', 'title']"
          :allowedSearchFields="searchableArray"
          :searchEnabled="searchEnabled"
          :result="totalRows"
        >
        </ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{ 'checkbox-width-limit': cols.checkbox }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!dataLoading">
                  <template v-if="!lodash.isEmpty(rowData)">
                    <tr
                      class="product-listing-row"
                      v-for="(data, index) in rowData"
                      :key="index"
                      link
                    >
                      <template v-for="cols in customThead">
                        <td
                          v-if="cols.visible"
                          :key="cols.id"
                          :class="{
                            'simple-table-td': !cols.checkbox,
                            'checkbox-width-limit': cols.checkbox,
                          }"
                          :style="{ 'max-width': cols.width }"
                          v-on:click="
                            Number(cols.checkbox) == 0
                              ? rowClicked(data)
                              : 'javascript:void(0)'
                          "
                        >
                          <template
                            v-if="cols.checkbox && Number(cols.checkbox) == 1"
                          >
                            <v-checkbox
                              dense
                              v-model="selectedRows"
                              v-bind:value="data.id"
                              color="cyan"
                              class="hide-margin"
                              hide-details
                            ></v-checkbox>
                          </template>
                          <template v-else-if="cols.field == 'barcode'">
                            <Barcode :barcode="data.barcode"></Barcode>
                          </template>
                          <template v-else-if="cols.field == 'status'">
                            <v-chip
                              class="mr-2 my-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                              :color="getStatusColor(data.status)"
                              small
                              label
                              :text-color="data.status == 2 ? 'white' : 'white'"
                            >
                              {{ data.status_text }}
                            </v-chip>
                            <CustomStatus
                              v-if="false"
                              endpoint="purchase-order/status"
                              small
                              :status="Number(data.status)"
                            >
                            </CustomStatus>
                          </template>
                          <template v-else-if="cols.field == 'payment_status'">
                            <v-chip
                              v-if="
                                data.payment_status &&
                                [2, 3, 5, 6].includes(Number(data.status))
                              "
                              class="mr-2 my-1 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                              :color="
                                getPaymentStatusColor(data.payment_status)
                              "
                              small
                              label
                              text-color="white"
                            >
                              {{ data.payment_status_text }}
                            </v-chip>
                            <em v-else class="text--secondary">N/A</em>
                          </template>
                          <template v-else-if="cols.field == 'title'">
                            <div class="purchase-order-listing-customer">
                              <v-tooltip
                                top
                                max-width="400"
                                content-class="custom-top-tooltip"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <p
                                    class="m-0 font-weight-bold custom-nowrap-ellipsis line-climp-content"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <template v-if="data.title">
                                      {{ data.title }}
                                    </template>
                                    <template v-else>
                                      <em class="text--secondary">No title</em>
                                    </template>
                                  </p>
                                </template>

                                <span>{{ data.title || "No title" }}</span>
                              </v-tooltip>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'quotation'">
                            <div
                              class="quotation-linked d-flex align-center flex-wrap gap-1"
                            >
                              <template v-if="getLinkedQuotations(data).length">
                                <template
                                  v-for="(quo, qIdx) in getLinkedQuotations(
                                    data
                                  ).slice(0, 1)"
                                >
                                  <router-link
                                    :key="qIdx"
                                    v-if="quo.id"
                                    :to="{
                                      name: 'admin.quotation.detail',
                                      params: { id: quo.id },
                                    }"
                                    class="text-decoration-none mr-1"
                                  >
                                    <v-chip
                                      small
                                      color="blue lighten-5"
                                      text-color="blue darken-4"
                                      class="font-weight-600 px-3 cursor-pointer"
                                    >
                                      <v-icon left small color="blue darken-4"
                                        >mdi-format-quote-close</v-icon
                                      >
                                      {{ quo.barcode }}
                                    </v-chip>
                                  </router-link>
                                  <v-chip
                                    v-else
                                    :key="qIdx"
                                    small
                                    color="blue lighten-5"
                                    text-color="blue darken-4"
                                    class="font-weight-600 px-2 py-1 mr-1"
                                  >
                                    <v-icon left small color="blue darken-4"
                                      >mdi-format-quote-close</v-icon
                                    >
                                    {{ quo.barcode }}
                                  </v-chip>
                                </template>

                                <v-menu
                                  v-if="getLinkedQuotations(data).length > 1"
                                  open-on-hover
                                  offset-y
                                  bottom
                                  content-class="bg-white elevation-3 rounded pa-1"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-chip
                                      small
                                      color="blue-grey lighten-5"
                                      text-color="blue-grey darken-3"
                                      class="font-weight-bold px-2 py-1 cursor-pointer"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      +{{
                                        getLinkedQuotations(data).length - 1
                                      }}
                                      more
                                    </v-chip>
                                  </template>
                                  <v-list
                                    dense
                                    class="py-0"
                                    style="min-width: 170px"
                                  >
                                    <div
                                      class="caption font-weight-bold px-3 py-2 text-secondary border-bottom"
                                    >
                                      Linked Quotations ({{
                                        getLinkedQuotations(data).length
                                      }})
                                    </div>
                                    <template
                                      v-for="(
                                        moreQuo, mIdx
                                      ) in getLinkedQuotations(data).slice(1)"
                                    >
                                      <v-list-item
                                        :key="mIdx"
                                        dense
                                        class="px-3 cursor-pointer"
                                        :to="
                                          moreQuo.id
                                            ? {
                                                name: 'admin.quotation.detail',
                                                params: { id: moreQuo.id },
                                              }
                                            : undefined
                                        "
                                      >
                                        <v-list-item-icon class="mr-2 my-auto">
                                          <v-icon small color="blue darken-4"
                                            >mdi-format-quote-close</v-icon
                                          >
                                        </v-list-item-icon>
                                        <v-list-item-title
                                          class="caption font-weight-600 blue--text text--darken-4"
                                        >
                                          {{ moreQuo.barcode }}
                                        </v-list-item-title>
                                      </v-list-item>
                                    </template>
                                  </v-list>
                                </v-menu>
                              </template>

                              <template v-else>
                                <v-chip
                                  small
                                  color="blue lighten-5"
                                  text-color="blue darken-4"
                                  class="font-weight-600 px-2 py-1"
                                  title="No quotation linked"
                                >
                                  <v-icon left small color="blue darken-4"
                                    >mdi-format-quote-close</v-icon
                                  >
                                  <em class="text--secondary caption"
                                    >No Quotation</em
                                  >
                                </v-chip>
                              </template>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'reference_no'">
                            <div class="purchase-order-listing-customer">
                              <v-tooltip
                                max-width="300"
                                top
                                content-class="custom-top-tooltip"
                                :disabled="!data.reference_no"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <p
                                    v-bind="attrs"
                                    v-on="on"
                                    class="m-0 custom-nowrap-ellipsis d-flex align-center"
                                  >
                                    <b class="mr-1">Reference #: </b>
                                    <template v-if="data.reference_no">
                                      <span
                                        class="custom-nowrap-ellipsis line-climp-content"
                                      >
                                        {{ data.reference_no }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <em class="text--secondary"
                                        >No Reference #</em
                                      >
                                    </template>
                                  </p>
                                </template>
                                <span>{{ data.reference_no }}</span>
                              </v-tooltip>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>PIC: </b>
                                <template v-if="data.pic_user">{{
                                  data.pic_user.display_name
                                }}</template>
                                <template v-else
                                  ><em class="text--secondary"
                                    >No pic</em
                                  ></template
                                >
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Order By: </b>
                                <template v-if="data.order_by_user">{{
                                  data.order_by_user.display_name
                                }}</template>
                                <template v-else
                                  ><em class="text--secondary"
                                    >No Order By</em
                                  ></template
                                >
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'supplier'">
                            <div
                              class="purchase-order-listing-amount"
                              v-if="!lodash.isEmpty(data.supplier)"
                            >
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ data.supplier.display_name }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ data.supplier.phone }}
                              </p>
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ data.supplier.company_name }}
                              </p>
                            </div>
                            <em v-else class="text--secondary">No Supplier</em>
                          </template>
                          <template v-else-if="cols.field == 'date'">
                            <div class="purchase-order-listing" align="center">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <template v-if="data.delivery_date">{{
                                  formatDate(data.delivery_date)
                                }}</template>
                                <template v-else
                                  ><em class="text--secondary"
                                    >No Delivery Date</em
                                  ></template
                                >
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'category'">
                            <div
                              class="purchase-order-listing-amount"
                              v-if="!lodash.isEmpty(data.category)"
                            >
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ data.category }}
                              </p>
                            </div>
                            <em v-else class="text--secondary">No Category</em>
                          </template>
                          <template v-else-if="cols.field == 'amount'">
                            <div class="purchase-order-listing-amount">
                              <p
                                class="m-0 custom-nowrap-ellipsis text--secondary font-size-13"
                              >
                                <b>Sub Total: </b>
                                <span>{{
                                  $accountingJS.formatMoney(data.sub_total || 0)
                                }}</span>
                              </p>
                              <p
                                class="m-0 custom-nowrap-ellipsis text--secondary font-size-13"
                                v-if="data.discount_amount"
                              >
                                <b>Discount: </b>
                                <span class="red--text font-weight-500"
                                  >-{{
                                    $accountingJS.formatMoney(
                                      data.discount_amount
                                    )
                                  }}</span
                                >
                              </p>
                              <p
                                class="m-0 custom-nowrap-ellipsis text--secondary font-size-13"
                              >
                                <b>Tax: </b>
                                <span>{{
                                  $accountingJS.formatMoney(
                                    data.tax_amount || 0
                                  )
                                }}</span>
                              </p>
                              <p
                                class="m-0 custom-nowrap-ellipsis primary--text font-weight-bold font-size-14"
                              >
                                <b>Total: </b>
                                <span>{{
                                  $accountingJS.formatMoney(data.total || 0)
                                }}</span>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'added_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.added_by)"
                              :data="data"
                            >
                              <template v-slot:first_letters>
                                {{
                                  getFirstLetters(data.added_by?.display_name)
                                }}
                              </template>
                              <template v-slot:display_name>
                                {{ data.added_by.display_name }}
                              </template>
                              <template v-slot:date_time>
                                <template
                                  v-if="getDateCountAll(data.added_at)"
                                  >{{ data.created_at }}</template
                                >
                                <template v-else>{{
                                  formatDateTime(data.added_at)
                                }}</template>
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else-if="cols.field == 'updated_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.updated_by)"
                              :data="data"
                            >
                              <template v-slot:first_letters>
                                {{
                                  getFirstLetters(data.updated_by?.display_name)
                                }}
                              </template>
                              <template v-slot:display_name>
                                {{ data.updated_by.display_name }}
                              </template>
                              <template v-slot:date_time>
                                {{ data.modified_at }}
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDateTime(data.updated_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else>
                            <div v-html="printRowData(cols, data)"></div>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr v-else-if="!dataLoading">
                    <td :colspan="8" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no purchase order at the moment.
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <v-navigation-drawer
          v-model="searchDialog"
          app
          bottom
          temporary
          stateless
          right
          :width="600"
          style="z-index: 500"
        >
          <v-card
            text
            elevation="0"
            class="d-flex flex-column h-100 custom-field"
          >
            <!-- Drawer Title -->
            <v-card-title
              class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
            >
              <span style="font-size: 18px"> Filter Purchase Order</span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="searchDialog = false">
                <v-icon size="30">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- Drawer Content -->
            <v-card-text class="flex-grow-1 px-3">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shadow"
                style="height: calc(100vh - 125px); position: relative"
              >
                <v-container fluid class="pt-0 custom-search-filter">
                  <v-row>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Date Range</label
                      >
                      <DateRangePicker
                        placeholder="Date Range"
                        v-model="dates"
                        v-on:click:clear="clearFilter('dates')"
                        class="mr-2"
                      ></DateRangePicker>
                    </v-col>
                    <template v-for="(field, index) in searchableArray">
                      <v-col md="12" :key="index" v-if="field != 'dates'">
                        <label
                          class="v-label font-weight-500 font-size-13 text-capitalize"
                          >{{ getFilterLabel(field, "Purchase Order") }}</label
                        >
                        <v-menu
                          v-if="isDateFilter(field)"
                          :value="datePicker === field"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          @input="datePicker = $event ? field : null"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="listingSearch[field]"
                              dense
                              filled
                              hide-details
                              :placeholder="
                                getFilterLabel(field, 'Purchase Order')
                              "
                              solo
                              flat
                              clearable
                              readonly
                              prepend-inner-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                              @click:clear="listingSearch[field] = null"
                              color="cyan"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="listingSearch[field]"
                            color="cyan"
                            @input="datePicker = null"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          v-else
                          v-model.trim="listingSearch[field]"
                          dense
                          filled
                          hide-details
                          :placeholder="getFilterLabel(field, 'Purchase Order')"
                          solo
                          flat
                          clearable
                          @keydown.enter="filterRows"
                          color="cyan"
                        ></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </perfect-scrollbar>
            </v-card-text>
            <!-- Drawer Actions -->
            <v-divider class="my-0"></v-divider>
            <v-card-actions class="d-flex justify-content px-4 pb-4">
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red white--text"
                v-on:click="removeFilters('clear')"
              >
                <v-icon left>mdi-close</v-icon>
                <span>Clear Filter</span>
              </v-btn>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="filterRows"
              >
                <v-icon left>mdi-magnify</v-icon>
                <span>Apply Filter</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Purchase Order Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus";
import DateRangePicker from "@/view/components/DateRangePicker";
import { SearchEventBus } from "@/core/lib/search.lib";
export default {
  mixins: [CommonMixin, ListingMixin],
  name: "purchase-order-list",
  data() {
    return {
      exportLoading: false,
      dates: [],
      datePicker: null,
      pageModule: "purchase-order-listing",
      routeAPI: "purchase-order",
      routeName: "purchase.order",
      routeDetailName: "purchase.order.detail",
      status: "all",
      statusList: [],
      customThead: [],
      moreActions: [
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      bulkActions: [
        {
          title: "Mark as Approved",
          action: "mark_as_approved",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Closed",
          action: "mark_as_closed",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Cancelled",
          action: "mark_as_cancelled",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = undefined;
        }
      },
    },
  },
  components: {
    PageHeaderCount,
    draggable,
    CustomStatus,
    PageTips,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    DateRangePicker,
  },
  methods: {
    isDateFilter(field) {
      return ["date", "delivery_date", "due_date"].includes(field);
    },
    removeFilters() {
      SearchEventBus.$emit("clear-search", true);
    },
    getStatusColor(status) {
      if (status == 1) {
        return "cyan";
      }
      if (status == 2) {
        return "green lighten-1";
      }
      if (status == 3) {
        return "orange";
      }
      if (status == 4) {
        return "red";
      }
      if (status == 5) {
        return "orange";
      }
      if (status == 6) {
        return "green";
      }
      return null;
    },
    getPaymentStatusColor(status) {
      if (status === "paid") {
        return "green lighten-1";
      }
      if (status === "partially_paid") {
        return "orange darken-1";
      }
      if (status === "unpaid") {
        return "red lighten-1";
      }
      return "blue-grey";
    },
    bulkAction(action) {
      const _this = this;
      switch (action) {
        case "mark_as_approved":
          _this.updatePurchaseOrder(2);
          break;
        case "mark_as_closed":
          _this.updatePurchaseOrder(3);
          break;
        case "mark_as_cancelled":
          _this.updatePurchaseOrder(4);
          break;
      }
    },
    updatePurchaseOrder(status) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "purchase-order/status",
          data: { purchase_order: _this.selectedRows, status },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },
    // new methods use for quotation Static
    getLinkedQuotations(data) {
      if (!data) return [];
      let list = [];

      if (Array.isArray(data.quotations) && data.quotations.length) {
        list = data.quotations;
      } else if (Array.isArray(data.quotation) && data.quotation.length) {
        list = data.quotation;
      } else if (
        Array.isArray(data.quotation_list) &&
        data.quotation_list.length
      ) {
        list = data.quotation_list;
      } else if (data.quotation && typeof data.quotation === "object") {
        list = [data.quotation];
      } else if (data.quotation && typeof data.quotation === "string") {
        list = [data.quotation];
      } else if (data.quotations && typeof data.quotations === "object") {
        list = [data.quotations];
      } else if (data.quotation_barcode) {
        list = [data.quotation_barcode];
      }

      const linkedQuotations = list
        .map((item) => {
          if (typeof item === "string" || typeof item === "number") {
            return { barcode: String(item), id: null };
          }
          if (item && typeof item === "object") {
            return {
              barcode:
                item.barcode ||
                item.quotation_barcode ||
                item.reference_no ||
                item.number ||
                item.name ||
                "",
              id: item.id || item.quotation_id || null,
            };
          }
          return null;
        })
        .filter((item) => item && item.barcode);

      return linkedQuotations.filter(
        (item, index, items) =>
          items.findIndex(
            (candidate) =>
              String(candidate.id || candidate.barcode) ===
              String(item.id || item.barcode)
          ) === index
      );
    },
    // new methods use for quotation Static
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          break;
        case "export_items":
          _this.bulkPurchaseOrderExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("purchase-order");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Purchase Order",
      },
    ]);
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
